import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/services/base.service';
import { DepartmentField, DepartmentModel, SearchDepartmentFilter } from '../pages/departments/models/department.model';
import { Observable } from 'rxjs';
import { ChemicalDepartment } from '../pages/departments/models/chemical-department.model';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService extends BaseService {
  public getDepartmentPaging(request: SearchDepartmentFilter): Observable<any> {
    return this.post('admin/getDepartments', request);
  }

  public deleteDepartments(ids: number[]): Observable<any> {
    return this.post('admin/departments/delete', ids);
  }

  public getAllDepartments(getForSetup = false): Observable<ChemicalDepartment[]> {
    return this.get(`admin/departments/${getForSetup}`);
  }

  public getAllUsers(): Observable<any[]> {
    return this.get('admin/users', {
      getForSetup: true,
    });
  }

  public getDepartmentById(id: any): Observable<DepartmentField> {
    return this.get(`admin/departments/get/${id}`);
  }

  public updateDepartmentInformation(data: DepartmentField): Observable<boolean> {
    return this.put('admin/departments', data);
  }

  public createDepartment(data: any): Observable<any> {
    return this.post('admin/departments', data);
  }

  public getEmployeeOfDepartmentPaging(departmentId: string, request: SearchDepartmentFilter): Observable<any> {
    return this.get(`admin/departments/${departmentId}/employees-paging`, request);
  }
}
